import { commaListSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { VerifyEmail } from "@/features/join/verify";

export const Route = createFileRoute("/(member)/(public)/join/verify")({
  component: VerifyEmail,
  validateSearch: z.object({
    email: z.email().optional(),
    id: z.string().optional(),
    firstName: z.string().optional(),
    planKey: z.string().optional(),
    discountCode: z.string().optional(),
    checkoutId: z.string().optional(),
    addOns: commaListSchema,
    referId: z.string().optional(),
    referredBy: z.string().optional(),
  }),
});
